<template>
  <!-- 获取自己政区下的数据 -->
  <div class="treeAnalyse">
    <div class="header clearfix">
      <p class="fl">
        <span>古树</span>
        <span
          ><em>{{ treeData.gsNum }}</em
          >株</span
        >
        <span
          >其中古树群<em>{{ treeData.gsGroupNum }}</em
          >个</span
        >
      </p>
      <p class="fr">
        <span>名木</span>
        <span
          ><em>{{ treeData.mmNum }}</em
          >株</span
        >
        <span
          >其中古树群<em>{{ treeData.mmGroupNum }}</em
          >个</span
        >
      </p>
    </div>
    <p class="fgx"></p>
    <div class="treeGradelist">
      <!-- 古树等级分布 -->
      <p class="ggTit">
        <a href="javascript:void(0)" class="tit">古树等级分布</a>
      </p>
      <span class="units">等级数量：株</span>
      <gg-cicle-chart :sourceList="gradeData"></gg-cicle-chart>
    </div>
    <p class="fgx"></p>
    <div class="treeLoactionList">
      <!-- 古树位置分布 -->
      <p class="ggTit">
        <a href="javascript:void(0)" class="tit">古树位置分布</a>
      </p>
      <div class="locationList">
        <ul class="wotitleList">
          <li
            class="wotitleLi"
            v-for="(item, index) in treeList"
            :key="'treeList' + index"
          >
            <span class="wotitleTitle">{{ item.name }}</span>
            <div class="lineWrap">
              <p
                class="line"
                :style="{
                  width:
                    treeMax > 0 ? (item.num * 100) / treeMax + '%' : '100%',
                }"
              ></p>
              <span class="num">{{ item.num }} 株</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <p class="fgx"></p>
    <div class="treeKindList">
      <!-- 古树树种分布 -->
      <p class="ggTit">
        <a href="javascript:void(0)" class="tit">古树树种分布</a>
      </p>
      <span class="units">树种数量：株</span>
      <gg-bar-chart :sourceList="shuzData"></gg-bar-chart>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
const ggBarChart = () => import("@/components/common/barChart");
const ggCicleChart = () => import("@/components/common/cicleChart");
export default {
  name: "treeAnalyse",
  components: {
    ggBarChart,
    ggCicleChart,
  },
  data() {
    return {
      treeData: {},
      regionCode: "", //政区编码
      gradeData: [], //古树等级
      shuzData: [], //古树树种
      treeMax: 0, //位置数据最大值
      treeList: [], //古树位置
      clientType: getDeviceType(),
    };
  },
  mounted() {
    document.title = "统计分析";
    this.regionCode = this.$route.query.zqCode;
    // this.getLogin(); //获取古树名木用户信息
    this.getResourceInfo();
    this.getAncientTreeNum();
    this.getAppRegionTreeNum();
  },
  methods: {
    // getLogin() {
    //   //获取用户信息
    //   let _this = this;
    //   _this.$api.slbkOldTree
    //     .getLogin()
    //     .then((res) => {
    //       if (res.code == "1") {
    //         console.log(res.data);
    //         _this.regionCode = res.data.zqCode;
    //         _this.getResourceInfo();
    //         _this.getAncientTreeNum();
    //         _this.getAppRegionTreeNum();
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    getResourceInfo() {
      let _this = this;
      _this.$api.slbkOldTree
        .getResourceInfo(_this.regionCode)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            // _this.gradeData = res.data.classList;
            res.data.classList.forEach((item) => {
              _this.gradeData.push({ type: item.name, numbers: item.num });
            });
            res.data.szList.forEach((item) => {
              _this.shuzData.push({ type: item.name, numbers: item.num });
            });
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAncientTreeNum() {
      let _this = this;
      _this.$api.slbkOldTree
        .getAncientTreeNum(_this.regionCode)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.treeData = res.data; //
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAppRegionTreeNum() {
      let _this = this;
      _this.$api.slbkOldTree
        .getAppRegionTreeNum(1, 9999, _this.regionCode)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.treeList = res.data.list;
            let list = res.data.list;
            var arry = list.map((item) => item.num);
            let treeMax = Math.max.apply(null, arry);
            _this.treeMax = treeMax;
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less">
.treeAnalyse {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  font-family: "PingFangSC";
  .fgx {
    width: 100%;
    height: 5px;
    background-color: #f4f4f4;
  }
  .header {
    width: 100%;
    padding: 0 16px;
    border-bottom: 1px solid #f9f9f9;
    p {
      width: 50%;
      text-align: center;
      span {
        display: block;
        font-size: 18px;
        color: #333;
        margin: 8px 0;
      }
      span:nth-child(2) {
        color: #000;
        em {
          font-size: 45px;
          font-weight: 600;
        }
        font-size: 16px;
      }
      span:last-child {
        font-size: 16px;
      }
    }
  }
  .ggTit {
    font-size: 18px;
    font-weight: 400;
    color: #333;
    line-height: 30px;
    padding: 0 20px;
    position: relative;
    > a.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 18px;
      background: #32b27d;
      top: 5px;
      left: 10px;
    }
  }
  .treeGradelist,
  .treeKindList,
  .treeLoactionList {
    position: relative;
    .units {
      position: absolute;
      font-size: 12px;
      color: #333;
    }
  }
  .treeGradelist {
    .units {
      top: 55px;
      left: 50%;
      margin-left: -30px;
    }
  }
  .treeKindList {
    .units {
      top: 55px;
      left: 50%;
      margin-left: -30px;
    }
  }
  .locationList {
    padding: 10px 0;
    .wotitleLi {
      margin-bottom: 10px;
      display: flex;
      padding: 0 16px;
      align-items: center;
      .wotitleTitle {
        width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #32b27d;
        margin-right: 10px;
        flex-shrink: 0;
      }
      .lineWrap {
        width: 100%;
        display: flex;
        align-items: center;
      }
      .line {
        width: 100%;
        height: 7px;
        background: linear-gradient(90deg, #0ed7ee, #0076ff);
        border-radius: 3px;
      }
      .num {
        flex-shrink: 0;
        color: #32b27d;
        font-size: 12px;
        display: block;
        padding-left: 10px;
      }
    }
  }
}
</style>